import React, { useEffect, useState } from "react";
import { Block, BlockHead, BlockHeadContent, BlockTitle, Icon, Col } from "../../../components/Component.js";
import { Button, Card, Modal, ModalBody, Spinner } from "reactstrap";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { toast } from "react-toastify";
import { getDeleteRequests } from "./deleteRequestsAPi.js";
import axios from "axios";
import { authHeader } from "../../../header.js";

export default function DeleteRequests() {
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState({ view: false });
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [showDeclineReason, setShowDeclineReason] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [deleteAccounts, setDeleteAccounts] = useState([]);
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [statusFilter, setStatusFilter] = useState("ALL");

  // Fetch delete requests from API
  async function fetchDeleteRequests() {
    setIsLoading(true);
    try {
      const response = await getDeleteRequests();
      console.log("API Response:", response);

      if (response?.status && response?.data) {
        setDeleteAccounts(response.data || []);
        setFilteredAccounts(response.data || []);
      } else {
        setDeleteAccounts([]);
        setFilteredAccounts([]);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Unknown error while fetching requests");
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchDeleteRequests();
  }, []);

  const onViewClick = (request) => {
    setSelectedRequest(request);
    setModal({ view: true });
    setShowDeclineReason(false);
    setDeclineReason("");
  };

  const onFormCancel = () => {
    setModal({ view: false });
    setSelectedRequest(null);
  };

  // Filter requests by status
  const applyFilter = () => {
    if (statusFilter === "ALL") {
      setFilteredAccounts(deleteAccounts);
    } else {
      const filtered = deleteAccounts.filter((req) => req.requestStatus === statusFilter);
      setFilteredAccounts(filtered);
    }
  };

  // Accept a pending delete request
  const handleAccept = async (request) => {
    try {
      console.log("Processing accept for request:", request);
      console.log(authHeader());

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/request-centre/treat/${request.id}?admin-usage=ADMIN_TREASURY`,
        { action: "APPROVE" },
        { headers: authHeader() }
      );

      if (response.data.status) {
        setModal({ view: false });
        toast.success(response.data.message || "Customer request approved!");
        fetchDeleteRequests(); // refresh list
      } else {
        toast.error(response.data.message || "Unknown error");
      }
    } catch (error) {
      console.error("Error accepting request:", error);
      toast.error("Something went wrong while accepting request.");
    }
  };

  // Decline a pending delete request
  const handleDeclineSubmit = async () => {
    try {
      console.log("Processing decline for request:", selectedRequest, "with reason:", "REASON_A");

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/request-centre/treat/${selectedRequest?.id}`,
        {
          action: "DECLINE",
          reason: declineReason, // replace with declineReason later
        },
        { headers: authHeader() }
      );

      if (response.data.status) {
        toast.success(response.data.message || "Request declined successfully");
        fetchDeleteRequests();
        setModal({ view: false });
      } else {
        toast.error(response.data.message || "Unknown error");
      }

      console.log("Decline response:", response.data);
    } catch (error) {
      console.error("Error declining request:", error);
      toast.error("Something went wrong while declining request.");
    }
  };

  // Helpers for User ID and Email
  const getUserId = (requester) => requester?.customerId || "N/A";
  const getUserEmail = (requester) => requester?.email || "N/A";

  return (
    <React.Fragment>
      <Head title="Delete Requests" />
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Delete Requests</BlockTitle>
              </div>
            </BlockHeadContent>
          </BlockHead>

          {/* Filter */}
          <div className="d-flex align-items-center mb-3">
            <select
              className="form-control w-auto mr-2"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="ALL">All</option>
              <option value="PENDING">Pending</option>
              <option value="COMPLETED">Completed</option>
            </select>
            <Button color="primary" size="sm" onClick={applyFilter}>
              Filter
            </Button>
          </div>

          <Card className="card-bordered card-preview" style={{ width: "100%", overflowX: "auto" }}>
            {isLoading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
                <Spinner color="primary" style={{ height: "3rem", width: "3rem" }} />
              </div>
            ) : filteredAccounts.length > 0 ? (
              <table className="table table-striped">
                <thead>
                  <tr style={{ backgroundColor: "#f5f6fa" }}>
                    <th style={{ color: "#8094ae" }}>Date of Request</th>
                    <th style={{ color: "#8094ae" }}>User ID</th>
                    <th style={{ color: "#8094ae" }}>Email</th>
                    <th style={{ color: "#8094ae" }}>User Name</th>
                    <th style={{ color: "#8094ae" }}>Status</th>
                    <th style={{ color: "#8094ae" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAccounts.map((req) => (
                    <tr key={req.id}>
                      <td>{req.requestDate}</td>
                      <td>{getUserId(req.requester)}</td>
                      <td>{getUserEmail(req.requester)}</td>
                      <td>{req.customerName || req.requesterName}</td>
                      <td>{req.requestStatus || "PENDING"}</td>
                      <td>
                        <Button size="sm" color="primary" onClick={() => onViewClick(req)}>
                          View
                        </Button>{" "}
                        {/* <Button size="sm" color="secondary" onClick={() => handleOtherAction("Other", req)}>
                          Other
                        </Button> */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="text-center p-3">
                <span className="text-silent">No Request found</span>
              </div>
            )}
          </Card>
        </Block>

        {/* Modal */}
        <Modal size="md" isOpen={modal.view} toggle={onFormCancel}>
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Request Details</h5>
              {selectedRequest ? (
                <>
                  <Col md="12" className="my-2">
                    <span className="font-weight-bold mr-1">User ID:</span>
                    <span>{getUserId(selectedRequest.requester)}</span>
                  </Col>
                  <Col md="12" className="my-2">
                    <span className="font-weight-bold mr-1">Email:</span>
                    <span>{getUserEmail(selectedRequest.requester)}</span>
                  </Col>
                  <Col md="12" className="my-2">
                    <span className="font-weight-bold mr-1">Name:</span>
                    <span>{selectedRequest.customerName || selectedRequest.requesterName}</span>
                  </Col>
                  <Col md="12" className="my-2">
                    <span className="font-weight-bold mr-1">Request Date:</span>
                    <span>{selectedRequest.requestDate}</span>
                  </Col>
                  <Col md="12" className="my-2">
                    <span className="font-weight-bold mr-1">Request Type:</span>
                    <span>{selectedRequest.requestType}</span>
                  </Col>
                  <Col md="12" className="my-2">
                    <span className="font-weight-bold mr-1">Status:</span>
                    <span>{selectedRequest.requestStatus || "PENDING"}</span>
                  </Col>

                  {/* CTA buttons */}
                  <div className="d-flex justify-content-end mt-3">
                    <Button color="success" size="sm" className="mr-2" onClick={() => handleAccept(selectedRequest)}>
                      Accept
                    </Button>
                    <Button color="danger" size="sm" onClick={() => setShowDeclineReason(true)}>
                      Decline
                    </Button>
                  </div>

                  {/* Decline reason dropdown */}
                  {showDeclineReason && (
                    <div className="mt-3">
                      <label htmlFor="declineReason">Reason for Decline</label>
                      <select
                        id="declineReason"
                        className="form-control"
                        value={declineReason}
                        onChange={(e) => setDeclineReason(e.target.value)}
                      >
                        <option value="">-- Select a reason --</option>
                        <option value="Pending wallet balance">Pending wallet balance</option>
                        <option value="Active investment plan">Active investment plan</option>
                        <option value="Pending transactions">Pending transactions</option>
                        <option value="Outstanding disputes">Outstanding disputes</option>
                        <option value="Compliance review hold">Compliance review hold</option>
                      </select>

                      <div className="d-flex justify-content-end mt-2">
                        <Button color="primary" size="sm" onClick={handleDeclineSubmit}>
                          Submit Decline
                        </Button>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <p>No details available</p>
              )}
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
}
